import { IInventoryPage } from '../../../inventory-page.interface';


export const RESEARCH_RESEARCH_REAL_TIME_RESEARCH_PAGE: IInventoryPage = {
	'route': '/research/research/real-time-research',
	'title': 'Real Time Research',
	'uiReference': [
		'Search Live',
		'Open live search options',
		'Research Amazon as it updates',
		'Search',
		'Live search options',
		'Control ranking and brand filtering.',
		'Enable sorting Keep incoming results ordered.',
		'Exclude official brands Remove known official-brand listings.',
		'Marketplace',
		'Product',
		'Sorting',
		'Stop',
		'Flying Research is loading the data live from Amazon, page by page. By scrolling down to the end of the list you trigger to load the next page of data.',
		'Please wait for all the designs in the page to load.',
		"That's all folks!",
		'Quality First',
		'Wake The Feeling',
		'Keep It Simple',
		'Paradox Of Choice',
		'Copy Yourself',
		'Black Black Black',
		'Copy To Louse',
		'Dogs, Cats, & Love',
		'Gift, Present & Funny',
		'Write Like You Speak',
		'JPEG, PNG, or SVG?',
		'Who Would Sue Me?',
		'Who Will Tell Me The Niches?',
		'The Perfect Keyword?',
		'Seasonal & Event Designs',
		'New On Merch By Amazon?',
		'Birthday 18 till 65, Go!',
		'Strange Hobbies',
		'Black Designs Matter',
		'Like Cats...But Be No Copycat',
		'Get Emotional',
		'Bad Days Make No Bad Month',
		'Quantity And Quality Are Equal',
		'Search for something new',
		'Get inspired don’t copy',
		'Search in different marketplaces',
		'Wake emotions with your design',
		'What Is The Real Time Research?',
		'Research Amazon in real time and see designs as they are collected. This gives you access to current Merch by Amazon and Kindle Direct Publishing results instead of a fixed snapshot.',
		'How Does It Work?',
		'Designs are collected directly from Amazon using the marketplace, product, and sorting choices above, so their order follows the live Amazon result set.',
		'How Can I Use It?',
		"Select your preferred filters and start a search. Enable sorting to preserve Amazon's original order, and stop the current crawl before beginning a different live query.",
		'Advantages Over Best Sellers?',
		'Best Seller research uses a finite catalog. Live research keeps crawling the available Amazon results, helping you uncover fresh designs and smaller niches beyond that catalog.',
		'Copy all ASINs',
		'ASIN Board',
		'Copy All ASINS',
		'Loading...',
		'Sorry, there was an internal error. Please contact support.',
		'Market distribution',
		'Live insights',
		'Niche snapshot',
		'Performance, pricing, and keyword signals from the designs collected in this live session.',
		'designs analyzed',
		'BSR coverage',
		'of designs are ranked',
		'Best BSR',
		'Strongest rank in this result set',
		'Average BSR',
		'Average across ranked designs',
		'Average price',
		'Current marketplace average',
		'Price range',
		'– n/a',
		'Lowest to highest listed price',
		'Language signals',
		'Keyword reach',
		'Top niche keywords',
		'Coverage shows the share of loaded designs using each keyword. Generic product and listing terms are excluded, and every design counts once.',
		'Search term',
		'titles',
		'extracted mentions',
		'All listing data',
		'Title usage',
		'Keyword intelligence',
		'Understand how these designs are listed',
		'Add keywords to the Keyword Board, or open one to explore matching best sellers.',
		'Design discovery',
		'Best sellers for “”',
		'Open in Search',
		'Finding related best sellers…',
		'No related designs found',
		'Analyzing live results',
		'Statistics will settle as more designs arrive.',
		'Getting started',
		'Discover fresh Amazon designs beyond a fixed bestseller index.',
		'Choose a marketplace, product, and sorting method above, then start a live search.',
		'Research guidance',
		'Show previous research tip',
		'Show next research tip',
		'Research tips',
		'Live research',
		'Here is a useful research tip while the first designs arrive.',
		'Research guide',
		'Remove from favorites',
		'Enter a tag',
		'Favorite tag',
		'Generate image using AI',
		'NEW',
		'History Rank :',
		'History Price : NA',
		'Removed',
		'ASIN',
		'review(s)',
		'Published since',
		'Saved',
		'Update tag',
		'Show BSR categories',
		'Show estimated sales history',
		'Show price history',
		'Open design details',
		'Platform:',
		'Category:',
		'ASIN :',
		'N/A',
		'BSR',
		'Sales',
		'Price',
		'Reviews',
		'Bulletpoints and Description',
		'View design',
		'&pound;',
		'&euro;',
		'Oh man, the board seems to be not included in the free version',
		'Open in KW Workbench',
		'Copy to Clipboard'
	],
	'sources': [
		'apps/flying-projects/frontend/webapp/src/app/pages/research/research/research-routing.module.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/research/live-research/live-research.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/research/live-research/live-research.data.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/research/live-research/live-research.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/research/shared/components/page-plugins/research-results-toolbar/research-results-toolbar.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/research/shared/components/page-plugins/research-results-toolbar/research-results-toolbar.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/research/shared/components/page-views/mba-design-view/mba-design-view.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/research/shared/components/page-views/mba-design-view/mba-design-view.component.html',
		'apps/flying-projects/frontend/webapp/src/app/components/inform-cards/api-loading-card/api-loading-card.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/components/inform-cards/api-loading-card/api-loading-card.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/research/live-research/live-research-statistics/live-research-statistics.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/research/live-research/live-research-statistics/live-research-statistics.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/research/shared/components/page-plugins/info/info.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/research/shared/components/page-plugins/info/info.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/research/shared/components/designs/card-carousel/card-carousel.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/research/shared/components/designs/card-carousel/card-carousel.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/research/shared/components/designs/mba/design-mba/design-mba.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/research/shared/components/designs/mba/design-mba/design-mba.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/research/shared/components/designs/mba/design-mba-detail/design-mba-detail.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/research/shared/components/designs/mba/design-mba-detail/design-mba-detail.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/keyword/shared/components/tables-and-helpers/kw-board/kw-board.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/keyword/shared/components/tables-and-helpers/kw-board/kw-board.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/research/shared/components/statistics/charts/distributions/distributions.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/research/shared/components/statistics/charts/distributions/distributions.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/keyword/shared/components/preview/word-frequency-keyword/word-frequency-keyword.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/keyword/shared/components/preview/word-frequency-keyword/word-frequency-keyword.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/research/shared/components/page-plugins/suggestions/suggestions.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/research/shared/components/page-plugins/suggestions/suggestions.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/research/shared/components/designs/design-carousel/design-carousel.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/research/shared/components/designs/design-carousel/design-carousel.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/research/shared/components/designs/mba/trends-badge/trends-badge.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/research/shared/components/designs/mba/trends-badge/trends-badge.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/research/shared/components/page-plugins/add-to-favorite/add-to-favorite.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/research/shared/components/page-plugins/add-to-favorite/add-to-favorite.component.html',
		'apps/flying-projects/frontend/webapp/src/app/components/chart/chart.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/components/chart/chart.component.html'
	],
	'aliases': []
};
